"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useABTest = exports.useABTests = void 0;
const react_1 = require("react");
const abtests_1 = require("./abtests");
const abtests_context_1 = require("./abtests-context");
const useABTests = (options = { includeAbsent: false }) => {
    const { tests } = (0, abtests_context_1.useABTestsContext)();
    return (0, react_1.useMemo)(() => [
        ...tests.filter((test) => options.includeAbsent || test.testValue !== abtests_1.TestCases.absent),
    ].reverse(), [tests]);
};
exports.useABTests = useABTests;
const useABTest = (testName) => {
    const tests = (0, exports.useABTests)({ includeAbsent: true });
    return (0, react_1.useMemo)(() => tests.find((test) => test.testName === testName), [tests]);
};
exports.useABTest = useABTest;
//# sourceMappingURL=abtests-hooks.js.map